class StylesHappymade {
    colors = {
        white: '#FFF',
        yellow: '#FFC',
        green: '#CFC',
        blue: '#CDF'
    };

    statusStyles = {
        done: {
            backgroundColor: this.colors.white,
        },
        todo: {
            backgroundColor: this.colors.green,
        },
        inProgress: {
            backgroundColor: this.colors.green,
        },
        future: {
            backgroundColor: this.colors.yellow,
        },
    };

    cssClasses = {
        'Done': 'done',
        'In progress': 'todo',
        'To do': 'todo',
        'Future': 'future'
    }

    status() {
        return this.statusStyles;
    };

    css(element, selected) {
        if(element.type === 'Task') {
            if(element.status === 'Done') {
                return 'done'
            } else {
                return 'inProgress';
            }
        } else {
            return this.cssClasses[element.status2 || element.status];
        }
    }
}

export default StylesHappymade;